import CategoryAndProductQAReport from "./CategoryAndProductQAReport.component";

export default CategoryAndProductQAReport;
